import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import StarIcon from '@material-ui/icons/Star'
import { Image } from '@components/atoms'
import useStyles from './tab-panel.styles'

function TabPanelFull(props) {
  const {
    accordionDetailHeading,
    accordionDetailBlurb,
    accordionDetailList,
    backgroundImage,
  } = props

  const styles = useStyles()

  return (
    <Box className={styles.tabPanelFullContainer}>
      <Image src={backgroundImage?.url} className={styles.bgImage} />
      <Box className={styles.tabPanelFull}>
        <Typography variant="h3" className={styles.tabPanelFullHeading}>{accordionDetailHeading}</Typography>
        {accordionDetailBlurb && (
          <Typography variant="body1" className={styles.tabPanelFullSupportiveCopy}>{accordionDetailBlurb}</Typography>
        )}
        <ul className={styles.starCardList}>
          {accordionDetailList && accordionDetailList.map((listItem) => {
            const isObject = typeof listItem === 'object' && listItem !== null
            const IconComponent = isObject ? listItem.icon : null
            const content = isObject ? listItem.value : listItem

            return (
              <li className={styles.starCardFull} key={`item-${isObject ? (listItem.label || listItem.value) : listItem}`}>
                <div className={styles.starPoint}>
                  {IconComponent ? <IconComponent /> : <StarIcon className={styles.starIcon} color="secondary" />}
                </div>
                <div className={styles.starCardCopy}>{content}</div>
              </li>
            )
          })}
        </ul>
      </Box>
    </Box>
  )
}

TabPanelFull.propTypes = {
  accordionDetailHeading: PropTypes.string,
  accordionDetailBlurb: PropTypes.string,
  accordionDetailList: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
        icon: PropTypes.elementType,
      }),
    ]),
  ),
  backgroundImage: PropTypes.object,
}

TabPanelFull.defaultProps = {}

export default TabPanelFull
